import { useNavigate } from 'react-router-dom';
import { Empty, Menu, Skeleton, Tooltip } from 'antd';
import { MenuItemType } from 'antd/es/menu/interface';
import { useLayoutContext } from '@/container/context/layout/layout-context';
import { MobileTeamCard } from './mobile-team-card';
import { SidebarTeamsProps } from '@modules/teams/teams.types';
import { FaChevronRight } from 'react-icons/fa6';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';
import { capitalize } from '@shared/utils/capitalize';

const style: MenuItemType['style'] = { height: 50, padding: 0, textAlign: 'center', lineHeight: 2.8 };

export function MobileSidebarTeamsView(props: SidebarTeamsProps) {
  const { t } = useTranslation();
  const {
    teams: { data, initialLoading, hasNextPage },
    layoutContext,
  } = props;
  const { closeSidebarMobileDrawer } = layoutContext;
  const navigate = useNavigate();
  const { isSubmenuOverlay, setIsSubmenuOverlay } = useLayoutContext();

  const teams = data?.data ? [...data.data] : [];

  const items = teams
    ?.map((team) => ({
      key: team?.id as string,
      title: '',
      label: <MobileTeamCard {...team} />,
      teamId: team?.id,
      teamName: team?.name,
    }))
    .map(({ teamId, teamName, ...item }) => ({
      ...item,
      style,
      onClick: () => {
        closeSidebarMobileDrawer();
        navigate('/settings/team-management/' + teamId + '?name=' + teamName);
      },
    }));

  return (
    <div className={clsx('flex flex-col items-center justify-center mt-5', hasNextPage ? 'mb-5' : 'mb-2')}>
      <p className="w-full px-4 text-center text-text-600 text-xs uppercase truncate">{t('team_other')}</p>
      {initialLoading ? (
        <Skeleton active paragraph={false} />
      ) : (
        <>
          {items && items?.length == 0 ? (
            <Empty
              image={Empty.PRESENTED_IMAGE_SIMPLE}
              className="justify-self-start! mx-auto! my-0! mt-4!"
              description={capitalize(t('empty'))}
            />
          ) : (
            <Menu className="mobile-custom-menu " style={{ border: 0, width: '100%' }} items={items} />
          )}
          {hasNextPage && (
            <Tooltip title={capitalize(t('view_all'))}>
              <button
                type="button"
                id="view-all"
                className={clsx(
                  'hover:bg-primary-50 text-text-400 rounded-full items-center group/view cursor-pointer',
                  'px-2 py-1 border border-text-100 mt-2 gap-2',
                  isSubmenuOverlay === 'teams' ? 'bg-primary-100' : ''
                )}
                onClick={() => setIsSubmenuOverlay((prev) => (prev === 'teams' ? null : 'teams'))}
              >
                <FaChevronRight size={10} style={{ transform: isSubmenuOverlay === 'teams' ? 'rotate(180deg)' : '' }} />
              </button>
            </Tooltip>
          )}
        </>
      )}
    </div>
  );
}
